import React, { Component } from 'react';

import Dialog from 'material-ui/Dialog';
import './alert.css';

class DeleteConfirm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
    };
  }

  handleClick = () => {
    const { bookingIdToDelete, cancelShift } = this.props;
    this.setState({ disabled: true });
    cancelShift(bookingIdToDelete);
    this.setState({ disabled: false });
  };

  render() {
    const { closeDialog, isDialogOpen } = this.props;
    return (
      <Dialog
        actions={
          <div className="buttons-div">
            <button type="button" disabled={this.state.disabled} className="alert-button" onClick={this.handleClick}>
              {this.state.disabled ? 'Loading' : 'YES'}
            </button>
            <button type="button" className="alert-button" onClick={closeDialog}>
              NO
            </button>
          </div>
        }
        open={isDialogOpen}
        paperProps={{ style: { borderRadius: '4px' } }}>
        <p style={{ textAlign: 'center' }}>Are you sure you want to cancel your shift?</p>
      </Dialog>
    );
  }
}

export default DeleteConfirm;



// WEBPACK FOOTER //
// ./src/components/Alert/DeleteConfirm.js